// Servicio para obtener equipos y simular el Super Bowl
import { API_CORE_URL } from "../constantes/constantes";

const API_BASE = `${API_CORE_URL}nfl2026`;

export const getPlayoffTeams = async () => {
  try {
    const response = await fetch(`${API_BASE}/playoff-teams`);
    if (!response.ok) throw new Error("Error fetching playoff teams");
    return await response.json();
  } catch (error) {
    console.error("Error in getPlayoffTeams:", error);
    throw error;
  }
};

export const generateBracket = async () => {
  try {
    const response = await fetch(`${API_BASE}/generate-bracket`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) throw new Error("Error generating bracket");
    return await response.json();
  } catch (error) {
    console.error("Error in generateBracket:", error);
    throw error;
  }
};

export const simulateGame = async (gameId, winnerTeam, bracket) => {
  try {
    // Crear una copia profunda del bracket
    let updatedBracket = JSON.parse(JSON.stringify(bracket));
    
    // Extraer el ID del equipo (puede ser string o objeto)
    const winnerTeamId = typeof winnerTeam === 'string' ? winnerTeam : winnerTeam.id;
    const winnerTeamObj = typeof winnerTeam === 'string' ? null : winnerTeam;

    // Función para encontrar el equipo completo en el bracket si solo tenemos el ID
    const findTeamInBracket = (bracketObj, teamId) => {
      if (bracketObj.wildCardRound && bracketObj.wildCardRound.games) {
        for (const game of bracketObj.wildCardRound.games) {
          if (game.homeTeam && game.homeTeam.id === teamId) return game.homeTeam;
          if (game.awayTeam && game.awayTeam.id === teamId) return game.awayTeam;
        }
      }
      if (bracketObj.divisionalRound && bracketObj.divisionalRound.games) {
        for (const game of bracketObj.divisionalRound.games) {
          if (game.homeTeam && game.homeTeam.id === teamId) return game.homeTeam;
          if (game.awayTeam && game.awayTeam.id === teamId) return game.awayTeam;
        }
      }
      if (bracketObj.conferenceChampionship && bracketObj.conferenceChampionship.game) {
        const game = bracketObj.conferenceChampionship.game;
        if (game.homeTeam && game.homeTeam.id === teamId) return game.homeTeam;
        if (game.awayTeam && game.awayTeam.id === teamId) return game.awayTeam;
      }
      return null;
    };

    // Función para actualizar el winner del juego específico
    const updateGameWinner = (bracketObj, gameId, winnerTeamId, winnerTeamObj) => {
      if (bracketObj.wildCardRound && bracketObj.wildCardRound.games) {
        const game = bracketObj.wildCardRound.games.find(g => g.id === gameId);
        if (game) {
          const teamObj = winnerTeamObj || findTeamInBracket(bracketObj, winnerTeamId);
          if (teamObj) {
            game.winner = teamObj;
          }
          return true;
        }
      }
      if (bracketObj.divisionalRound && bracketObj.divisionalRound.games) {
        const game = bracketObj.divisionalRound.games.find(g => g.id === gameId);
        if (game) {
          const teamObj = winnerTeamObj || findTeamInBracket(bracketObj, winnerTeamId);
          if (teamObj) {
            game.winner = teamObj;
          }
          return true;
        }
      }
      if (bracketObj.conferenceChampionship && bracketObj.conferenceChampionship.game) {
        if (bracketObj.conferenceChampionship.game.id === gameId) {
          const teamObj = winnerTeamObj || findTeamInBracket(bracketObj, winnerTeamId);
          if (teamObj) {
            bracketObj.conferenceChampionship.game.winner = teamObj;
          }
          return true;
        }
      }
      return false;
    };

    // Actualizar el juego en AFC o NFC
    let updated = false;
    if (updatedBracket.afc && !updated) {
      updated = updateGameWinner(updatedBracket.afc, gameId, winnerTeamId, winnerTeamObj);
    }
    if (updatedBracket.nfc && !updated) {
      updated = updateGameWinner(updatedBracket.nfc, gameId, winnerTeamId, winnerTeamObj);
    }
    if (updatedBracket.superBowl && updatedBracket.superBowl.game && !updated) {
      if (updatedBracket.superBowl.game.id === gameId) {
        const teamObj = winnerTeamObj || findTeamInBracket(updatedBracket.superBowl, winnerTeamId);
        if (teamObj) {
          updatedBracket.superBowl.game.winner = teamObj;
        }
        updated = true;
      }
    }

    const payload = {
      gameId,
      winnerId: winnerTeamId,
      bracket: updatedBracket,
    };
    
    const response = await fetch(`${API_BASE}/simulate-game`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      console.error("API Error:", errorData);
      throw new Error(errorData.message || "Error simulating game");
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in simulateGame:", error);
    throw error;
  }
};

export const getSuperBowlWinner = (bracket) => {
  try {
    // Buscar el juego del Super Bowl en el bracket
    if (bracket.superBowl && bracket.superBowl.game && bracket.superBowl.game.winner) {
      return bracket.superBowl.game.winner;
    }
    return null;
  } catch (error) {
    console.error("Error in getSuperBowlWinner:", error);
    return null;
  }
};

export const getConferenceWinner = (bracket, conference) => {
  try {
    const confKey = conference.toLowerCase();
    if (bracket[confKey] && bracket[confKey].champion) {
      return bracket[confKey].champion;
    }
    return null;
  } catch (error) {
    console.error("Error in getConferenceWinner:", error);
    return null;
  }
};
